import { createFileRoute } from '@tanstack/react-router';

import { ProviderJobPage } from '@/features/services/provider/jobs-pages';

export const Route = createFileRoute('/_app/me/services/jobs/$jobId')({ component: PageRoute });

function PageRoute() {
  const { jobId } = Route.useParams();
  return <ProviderJobPage jobId={jobId} />;
}
